export default "__VITE_ASSET__iuwneDyF__"